import { useVpsHostingSectionContent } from './useVpsHostingSectionContent';
import { parseVpsHostingRequestToResponseContent } from '../utils/vpsHostingContent';

export const useVpsHostingRequestToResponseContent = () =>
  useVpsHostingSectionContent(parseVpsHostingRequestToResponseContent);
